import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img 
            src={`${process.env.PUBLIC_URL}/images/logo.jpeg`}
            alt="Pragati Vidyalaya Logo"
            className="logo-img"
            onError={(e) => {
              // Fallback to text if local image fails
              e.target.style.display = 'none';
              const logoText = e.target.nextSibling;
              if (logoText) logoText.style.display = 'block';
            }}
          />
          <h1 className="logo-text" style={{display: 'none'}}>PRAGATI VIDYALAYA</h1>
        </div>
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
          <Link to="/about" onClick={() => setIsMenuOpen(false)}>About US</Link>
          <Link to="/preschool" onClick={() => setIsMenuOpen(false)}>Balvatika</Link>
          <Link to="/offerings" onClick={() => setIsMenuOpen(false)}>Offerings</Link>
          <Link to="/facility" onClick={() => setIsMenuOpen(false)}>Facility</Link>
          <Link to="/gallery" onClick={() => setIsMenuOpen(false)}>Gallery</Link>
          <Link to="/faculty" onClick={() => setIsMenuOpen(false)}>Faculty</Link>
          <Link to="/calendar" onClick={() => setIsMenuOpen(false)}>Calendar</Link>
          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact US</Link>
          <Link to="/disclosures" onClick={() => setIsMenuOpen(false)}>MANDATORY DISCLOSURES</Link>
        </nav>
        <button className="menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;

